'use client';

import { useState } from 'react';
import { ChevronDown } from 'lucide-react';

/**
 * Footer column wrapper. On mobile (<lg), renders as a collapsible accordion
 * to avoid the 60+ links eating screen space. On lg+, always-visible columns.
 * Children are server-rendered so SEO/crawlers see all the footer links in the
 * initial HTML payload regardless of expand state.
 */
export default function FooterAccordionColumn({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) {
  const [open, setOpen] = useState(false);

  return (
    <div>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
        className="w-full flex items-center justify-between text-left text-lg font-bold mb-3 lg:mb-5 text-white lg:pointer-events-none lg:cursor-default lg:py-0 py-3 min-h-11 lg:min-h-0"
      >
        <span className="relative inline-block">
          {title}
          <span className="absolute -bottom-1 left-0 w-8 h-0.5 bg-accent-yellow rounded-full" />
        </span>
        <ChevronDown
          className={`lg:hidden w-5 h-5 text-white/70 transition-transform ${open ? 'rotate-180' : ''}`}
          aria-hidden="true"
        />
      </button>
      <div className={`${open ? 'block' : 'hidden'} lg:block`}>{children}</div>
    </div>
  );
}
